import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createObjectCollectionReduceObject } from '../../../../../common/reducers/objectCollection/reducer';
import specialPagesCollectionSaga from './sagas/specialPagesCollectionSaga';

export default [
  ...createCombineMapItem(
    'specialPagesCollection',
    createObjectCollectionReduceObject,
    [specialPagesCollectionSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/specialPages/reducers/static/collections/reducersMap.js